import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { type ProfileType } from '@rma/generic/domain/types';
import { appendToRmaApiUrl } from '@rma/generic/ng/util';
import { Observable } from 'rxjs';
import { MarketReportCommunicationRequest } from '../../domain';
import { MarketReport } from '../../domain/market-report';

@Injectable({
  providedIn: 'root',
})
export class MarketReportApiService {
  private readonly httpClient = inject(HttpClient);
  private readonly rmaApiUrl = inject(appendToRmaApiUrl);

  public getReport(
    reportCode: string,
    isPrintMode = 'false',
    profileType?: ProfileType | null,
    profileCode?: string | null,
  ): Observable<MarketReport> {
    const optionalParams: Record<string, string> = {};

    if (profileType != null && profileCode != null) {
      optionalParams.profileType = profileType;
      optionalParams.profileCode = profileCode;
    }

    const params = {
      isPrintMode,
      ...optionalParams,
    };

    const endpoint = this.rmaApiUrl(`v2/PublishedListingReports/Code-${reportCode}`);
    return this.httpClient.get<MarketReport>(endpoint, { params: params });
  }

  public publishReport(reportId: number, transactionType: string, profileType: ProfileType, profileCode: string) {
    const endpoint = this.rmaApiUrl(`v2/${profileType}/${profileCode}/ListingReports/${reportId}/Publish/${transactionType}`);
    return this.httpClient.put<void>(endpoint, null);
  }

  public getPdf(reportId: number): Observable<string> {
    const endpoint = this.rmaApiUrl(`v2/ListingReports/${reportId}/PDFUrl`);
    return this.httpClient.get<string>(endpoint);
  }

  public sendComms(
    reportId: number,
    commsType: 'Email' | 'SMS',
    profileType: ProfileType,
    profileCode: string,
    request: MarketReportCommunicationRequest,
  ) {
    const endpoint = this.rmaApiUrl(`${profileType}/${profileCode}/ListingReports/${reportId}/${commsType}`);
    return this.httpClient.post(endpoint, request);
  }
}
